<mat-dialog-content class="main">
    <p [innerHTML]="data.content"><strong></strong></p>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="yesButton" fxFlexAlign="flex-start" (click)="Confirm()">Ok</button>
</mat-dialog-actions>
